export default __webpack_public_path__ + "static/media/blitz.9c20497a.svg";